import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaRe260 } from '~/endpoints/ApiTaRe260'
import compareSubjectOrder from '~/utils/subjects'
// State types

type StateSchoolOfChoice = {
  placementTestSchoolScore: {
    scoreList: {
      subjectCode: string
      score: string
    }[]
    choiceSchoolScoreList: {
      choiceSchoolName: string
      averageList: {
        subjectCode: string
        averageScore: string
      }[]
    }[]
  }
}
const getEmptyStateSchoolOfChoice = (): StateSchoolOfChoice => ({
  placementTestSchoolScore: {
    scoreList: [
      {
        subjectCode: '',
        score: '',
      },
    ],
    choiceSchoolScoreList: [
      {
        choiceSchoolName: '',
        averageList: [
          {
            subjectCode: '',
            averageScore: '',
          },
        ],
      },
    ],
  },
})

// State action parameter

interface ActionParamsRefreshSchoolOfChoice {
  fiscalYear: number
  month: number
  testCount?: number
  grade: number
  courseId: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/schoolOfChoice',
})
export default class SchoolOfChoice extends VuexModule {
  private schoolOfChoice_ = getEmptyStateSchoolOfChoice()

  // Getters
  get schoolOfChoice(): StateSchoolOfChoice {
    return this.schoolOfChoice_
  }

  // Mutations
  @Mutation
  updateSchoolOfChoice(value: StateSchoolOfChoice) {
    this.schoolOfChoice_ = value
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateSchoolOfChoice', getEmptyStateSchoolOfChoice())
  }

  @Action
  async refreshSchoolOfChoice(param: ActionParamsRefreshSchoolOfChoice) {
    logger.trace('in: refreshSchoolOfChoice')
    const api = new ApiTaRe260.Api()

    // API:
    const result = await api.get<StateSchoolOfChoice | null>(
      {
        query: {
          fiscalYear: param.fiscalYear,
          month: param.month,
          testCount: param.testCount,
          grade: param.grade,
          courseId: param.courseId,
        },
      },
      // success
      (data, _) => {
        return {
          placementTestSchoolScore: {
            ...data.placementTestSchoolScore,
            scoreList: data.placementTestSchoolScore.scoreList
              .sort((a, b) => {
                return compareSubjectOrder(a.subjectCode, b.subjectCode)
              })
              .filter(score => score.subjectCode !== 'S3J'),
            choiceSchoolScoreList: data.placementTestSchoolScore.choiceSchoolScoreList.map(choiceSchoolScore => {
              return {
                ...choiceSchoolScore,
                averageList: choiceSchoolScore.averageList
                  .sort((a, b) => {
                    return compareSubjectOrder(a.subjectCode, b.subjectCode)
                  })
                  .filter(score => score.subjectCode !== 'S3J'),
              }
            }),
          },
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)

        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSchoolOfChoice', result)
  }
}
